import { useZocksAuth } from '../../../components/ScopedBlock/hooks'

// Account admins, and RFG schedulers through their custom scope, can edit the account's scheduling setup
export const useCanEditAccountScheduling = (): boolean => {
  const { hasScope } = useZocksAuth()
  return hasScope('**', 'account_config:update', ['account_config:admin']) || hasScope('**', 'sched:admin', [])
}
